<template>
  <div class="FormSectionTemplate">
    <!--
      TODO: implement form
      promptId: number
      name: string
      icon: string
      hasTitle: boolean
      schema: (object)
      fields: object[]
      fieldsFill: string
      fieldsFillArguments: string[]
      questionsInitial: string[]
      keyPoints: string[]
      adjustments: (object)
        engine: string
        maxTokens: number
        frequencyPenalty: number
        presencePenalty: number
        temperature: number
        topProbability: number
        stop: string[]
    -->
    <Field
      :label="$t('name')"
      type="text"
      :value.sync="sectionTemplate.name" />
    <Field
      :label="$t('prompt')"
      :options="promptOptions"
      type="select"
      :value.sync="sectionTemplate.promptId" />
    <FieldList
      :items="sectionTemplate.keyPoints"
      :label="$t('keyPoints')"
      type="textarea"
      @update:items="$up('sectionTemplate.keyPoints', $event)" />
    <FieldList
      :items="sectionTemplate.questionsInitial"
      :label="$t('questionsInitial')"
      type="textarea"
      @update:items="$up('sectionTemplate.questionsInitial', $event)" />
    {{ sectionTemplate }}
  </div>
</template>

<script>
import FieldList from '@forms/FieldList'
import { getters } from '@utils'

export default {
  components: {
    FieldList,
  },
  props: {
    sectionTemplate: Object,
  },
  computed: {
    ...getters('promptOptions'),
  },
}
</script>

<style lang="scss">
.FormSectionTemplate {
}
</style>

<i18n>
{
  "en": {
    "name": "Name",
    "prompt": "Prompt",
    "keyPoints": "Key points",
    "keyFactsLabels": "Key facts labels",
    "questionsInitial": "Seed questions"
  }
}
</i18n>
